import { render, staticRenderFns } from "./StatisticsHeader.vue?vue&type=template&id=4760e062&scoped=true&"
import script from "./StatisticsHeader.vue?vue&type=script&lang=js&"
export * from "./StatisticsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4760e062",
  null
  
)

export default component.exports